export const DOWNLOAD_TRANSACTIONS_REPORT_API = "api/v1/download-report";
export const GET_ALL_PROCEDURES_API = "doctor/get-all-procedures";

export const GET_DOCTOR_TRANSACTIONS_DATA = "api/my-transactions-rev4";
export const GET_STAFF_TRANSACTIONS_DATA = "staff/my-transactions-rev4";
export const DOWNLOAD_STAFF_REPORT_API = "/api/v1/staff-download-report";

export const GET_DOCTOR_COLLECTIONS_SUMMARY = "/clinic/get-day-summary";
export const GET_DOCTOR_COLLECTIONS_DETAILS = "/clinic/get-day-collection";
export const GET_STAFF_COLLECTION_SUMMARY = "/clinic/staff-get-day-summary";
export const GET_STAFF_COLLECTIONS_DETAILS = "/clinic/staff-get-day-collection";
export const DOWNLOAD_DAY_COLLECTION = "/clinic/download-report/day-collection";
